module.exports = __webpack_public_path__ + "./img/livekasmbg.afa4fea1a5c2cfa4ba1eb09b2b8a5577.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/livekasmbg.png
// module id = ./assets/images/livekasmbg.png
// module chunks = 0